import axiosInstance from "./axiosInstance";

export async function templatePegawaiCsv() {
  return await axiosInstance.get("pegawai/download-csv", {responseType: 'blob'});
}

export async function uploadPegawaiCsv(data) {
  const formData = new FormData();
  formData.append("file", data);
  return await axiosInstance.post("pegawai/import", formData);
}